import { useMemo } from 'react';
import { getAgeFromBirthDate } from '~/core/util/date';
import { useCurrentCareRegion } from '~/hooks/useCurrentCareRegion';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';

const useShowLabs = () => {
  const profile = useSelectActiveUserProfile();
  const careRegion = useCurrentCareRegion();

  return useMemo(() => {
    if (['AK', 'HI', 'AZ'].indexOf(careRegion) !== -1) {
      return false;
    }

    return (getAgeFromBirthDate(profile?.birth_date) ?? 0) > 18;
  }, [careRegion, profile?.birth_date]);
};

export default useShowLabs;
